var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptisonLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 196.33 78.413",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath685"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 1080h1920v-1080h-1920z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 -199.78 1240)",
    clipPath: "url(#clipPath685)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(162.34,910.85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c4.261 0 6.329 3.879 6.329 6.901 0 3.054-2.068 6.964-6.392 6.964-4.167 0-6.425-3.561-6.425-6.868 0-3.626 2.449-6.997 6.488-6.997m-0.096 19.146c7.252 0 12.436-5.661 12.436-12.213 0-6.551-5.153-12.213-12.467-12.213-7.411 0-12.372 5.884-12.372 11.926 0 1.559 0.223 3.309 0.923 5.026 1.239 3.053 4.898 7.474 11.48 7.474",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(183.67,918.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h2.45c1.144 0 3.752 0 3.752 2.83 0 2.767-2.672 2.767-3.976 2.767h-2.226zm-5.757 10.878h7.697c4.357 0 5.98-0.669 7.252-1.719 1.844-1.525 2.766-3.848 2.766-6.233s-0.986-4.898-2.481-6.17c-1.621-1.368-3.211-2.036-6.868-2.036h-2.609v-7.378h-5.757z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200.97,924.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-4.643v5.28h15.266v-5.28h-4.612v-18.255h-6.011z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(214.01,929.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.011l-1e-3 -23.536h-6.01z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(233.5,922.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.127 0.796-0.318 2.29-2.162 2.29-1.051 0-2.068-0.732-2.068-1.845 0-1.399 0.635-1.685 4.865-3.593 4.39-1.972 5.502-4.008 5.502-6.742 0-3.436-1.97-7.221-8.205-7.221-6.805 0-8.492 4.453-8.492 7.474v0.764h5.98c0-2.734 1.685-3.212 2.448-3.212 1.432 0 2.291 1.176 2.291 2.258 0 1.558-0.986 1.94-4.612 3.467-1.654 0.668-5.756 2.321-5.756 6.742 0 4.422 4.293 6.933 8.237 6.933 2.321 0 4.835-0.859 6.362-2.671 1.398-1.718 1.493-3.309 1.557-4.644z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(253.98,910.85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c4.261 0 6.329 3.879 6.329 6.901 0 3.054-2.068 6.964-6.392 6.964-4.167 0-6.425-3.561-6.425-6.868 0-3.626 2.449-6.997 6.488-6.997m-0.094 19.146c7.25 0 12.434-5.661 12.434-12.213 0-6.551-5.152-12.213-12.467-12.213-7.411 0-12.372 5.884-12.372 11.926 0 1.559 0.223 3.309 0.923 5.026 1.239 3.053 4.898 7.474 11.482 7.474",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(269.56,929.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.185l9.094-14.79 0.064 0.064-0.253 14.726h5.755v-23.536h-5.215l-8.969 14.312-0.063-0.031 0.159-14.281h-5.757z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(293.99,929.33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-0.341h-0.973v-2.539h-0.393v2.539h-0.972v0.341z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(294.33,929.33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h0.559l0.826-2.435 0.823 2.435h0.554v-2.88h-0.371v1.699c0 0.059 3e-3 0.158 7e-3 0.294 5e-3 0.135 6e-3 0.281 6e-3 0.436l-0.827-2.429h-0.388l-0.831 2.429v-0.088c0-0.071 2e-3 -0.179 6e-3 -0.323 6e-3 -0.143 7e-3 -0.251 7e-3 -0.319v-1.699h-0.371z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(293.99,929.33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-0.341h-0.973v-2.539h-0.393v2.539h-0.972v0.341z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(294.33,929.33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h0.559l0.826-2.435 0.823 2.435h0.554v-2.88h-0.371v1.699c0 0.059 3e-3 0.158 7e-3 0.294 5e-3 0.135 6e-3 0.281 6e-3 0.436l-0.827-2.429h-0.388l-0.831 2.429v-0.088c0-0.071 2e-3 -0.179 6e-3 -0.323 6e-3 -0.143 7e-3 -0.251 7e-3 -0.319v-1.699h-0.371z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(151.72,886.79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.035 2.064-1.609 4.395-1.559 6.711-0.05 2.315 0.536 4.647 1.559 6.711l0.638-0.33c-0.971-1.939-1.533-4.176-1.481-6.381-0.052-2.221 0.51-4.443 1.481-6.379z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.16,894.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h0.345c1.253 0 1.406 0.567 1.444 2.094 0 1.639-0.358 2.08-1.611 2.08h-0.178zm-0.895-6.695v11.879h0.997c1.379 0 2.607-0.159 2.607-3.09 0-2.299-0.653-3.102-2.479-3.102h-0.23v-5.687z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(159.98,892.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-0.013 0.142c-0.025 0.772-0.05 2.411-0.92 2.411-0.792 0-0.971-1.828-0.971-2.553zm-1.916-0.867v-0.235c0-0.804 0.115-2.757 1.021-2.757 0.728 0 0.832 1.26 0.832 1.906h0.854c-0.011-1.229-0.395-2.867-1.609-2.867-1.725 0-1.955 2.521-1.955 4.142 0 1.45 0.256 4.19 1.84 4.19 1.533 0 1.776-2.471 1.776-3.889v-0.49z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162.86,895.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h0.025c0.18 0.568 0.537 1.213 1.086 1.197v-1.197l-0.166 0.015c-0.855 0-0.945-1.023-0.945-2.316v-4.709h-0.831v8.082h0.831z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(166.8,895.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-1.086v-7.137h-0.83v7.137h-0.703v0.945h0.703v2.379c0 1.371 0.293 2.268 1.226 2.268 0.243 0 0.498-0.047 0.728-0.172v-1.119c-0.178 0.172-0.358 0.346-0.6 0.346-0.459 0-0.524-0.488-0.524-1.291v-2.411h1.086z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168.24,888.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-0.831v12.602h0.831z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(170.17,896.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-5.073c0-1.103 0.051-2.173 0.868-2.173 0.843 0 0.883 1.07 0.895 2.173v5.073h0.831v-5.94c0-1.353-0.536-2.267-1.713-2.267-1.163 0-1.712 0.898-1.712 2.267v5.94z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176.12,895.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-1.086v-7.137h-0.83v7.137h-0.703v0.945h0.703v2.206h0.83v-2.206h1.086z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.38,895.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h0.025c0.18 0.567 0.537 1.213 1.086 1.197v-1.197l-0.166 0.015c-0.855 0-0.945-1.023-0.945-2.316v-4.709h-0.831v8.082h0.831z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(181.75,892.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-0.013 0.141c-0.025 0.773-0.05 2.412-0.92 2.412-0.792 0-0.971-1.828-0.971-2.553zm-1.916-0.867v-0.236c0-0.803 0.115-2.756 1.021-2.756 0.728 0 0.832 1.26 0.832 1.906h0.854c-0.011-1.229-0.395-2.867-1.609-2.867-1.725 0-1.955 2.521-1.955 4.142 0 1.45 0.256 4.19 1.84 4.19 1.533 0 1.776-2.471 1.776-3.889v-0.49z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(184.38,895.61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.332 0.473 0.78 0.771 1.29 0.771 1.163 0 1.266-1.322 1.266-2.425v-5.782h-0.832v5.672c1e-3 0.961-0.051 1.701-0.741 1.701-0.945 0-0.983-1.277-0.983-2.127v-5.246h-0.831v8.082h0.831z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(191.32,894.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h0.345c1.253 0 1.406 0.567 1.444 2.094 0 1.64-0.358 2.08-1.611 2.08h-0.178zm-0.895-6.695v11.879h0.997c1.379 0 2.607-0.159 2.607-3.09 0-2.299-0.651-3.102-2.479-3.102h-0.23v-5.687z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(195.64,895.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h0.025c0.18 0.567 0.537 1.213 1.086 1.197v-1.197l-0.166 0.015c-0.855 0-0.945-1.023-0.945-2.316v-4.709h-0.831v8.082h0.831z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(197.58,892.23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-0.789 0.025-3.213 1.023-3.213 0.996 0 1.021 2.424 1.021 3.213 0 0.772-0.025 3.198-1.021 3.198-0.998 0-1.023-2.426-1.023-3.198m2.901 0c0-1.529-0.154-4.174-1.878-4.174-1.726 0-1.879 2.645-1.879 4.174 0 1.512 0.153 4.158 1.879 4.158 1.725 0 1.878-2.646 1.878-4.158",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(203.71,895.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-1.086v-7.137h-0.83v7.137h-0.703v0.945h0.703v2.206h0.83v-2.206h1.086z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(206.72,892.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-0.013 0.141c-0.025 0.773-0.052 2.412-0.92 2.412-0.791 0-0.971-1.828-0.971-2.553zm-1.918-0.867v-0.236c0-0.803 0.117-2.756 1.023-2.756 0.728 0 0.83 1.26 0.83 1.906h0.856c-0.013-1.229-0.396-2.867-1.609-2.867-1.725 0-1.955 2.521-1.955 4.142 0 1.45 0.256 4.19 1.84 4.19 1.533 0 1.776-2.471 1.776-3.889v-0.49z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(209.35,888.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-0.83v8.082h0.83zm-0.41 9.703c-0.345 0-0.625 0.346-0.625 0.772 0 0.41 0.281 0.756 0.625 0.756 0.334 0 0.614-0.346 0.614-0.756 0-0.426-0.28-0.772-0.614-0.772",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(211.33,895.61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.332 0.473 0.778 0.771 1.29 0.771 1.163 0 1.264-1.322 1.264-2.425v-5.782h-0.83l1e-3 5.672c0 0.961-0.051 1.701-0.742 1.701-0.945 0-0.983-1.277-0.983-2.127v-5.246h-0.831v8.082h0.831z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(214.46,893.83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1.993v-1.244h-1.993z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(220.34,899.05)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-1.444l-1e-3 -10.87h-0.893v10.87h-1.444v1.008h3.782z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.67,885.09)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-0.868l0.651 3.307-1.559 7.862h0.843l1.1-6.522h0.038c0.115 0.693 0.217 1.386 0.345 2.08l0.843 4.442h0.868z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.25,892.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 1.244-0.012 3.246-0.971 3.246-0.882 0-0.92-1.67-0.92-3.105 0-1.559 0.051-3.559 0.958-3.559 0.766 0 0.933 0.928 0.933 3.418m-1.814 3.402h0.025c0.256 0.442 0.549 0.678 1.023 0.678 1.519 0 1.622-2.442 1.622-4.08 0-1.828-0.038-4.254-1.559-4.254-0.473 0-0.843 0.299-1.086 0.756h-0.025l-1e-3 -3.717h-0.829v11.17h0.83z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231.65,892.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-0.013 0.141c-0.025 0.773-0.05 2.412-0.92 2.412-0.792 0-0.971-1.828-0.971-2.553zm-1.916-0.867v-0.236c0-0.803 0.115-2.756 1.021-2.756 0.728 0 0.832 1.26 0.832 1.906h0.854c-0.013-1.229-0.396-2.867-1.609-2.867-1.725 0-1.955 2.521-1.955 4.142 0 1.45 0.256 4.19 1.84 4.19 1.533 0 1.776-2.471 1.776-3.889v-0.49z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.97,891.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-0.64 4.553c-0.115 0.803-0.165 1.621-0.241 2.425h-0.052c-0.09-0.804-0.153-1.622-0.255-2.425l-0.562-4.553zm1.456-3.403h-0.958l-0.358 2.442h-2.043l-0.345-2.442h-0.959l1.891 11.878h0.843z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(249.23,888.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-0.881l-0.677 8.76c-0.026 0.377-0.038 0.74-0.051 1.117h-0.052c-0.077-0.787-0.102-1.56-0.217-2.347l-1.048-7.53h-0.728l-1.061 8.76c-0.05 0.377-0.077 0.74-0.114 1.117h-0.039c-0.025-0.771-0.012-1.576-0.089-2.332l-0.766-7.545h-0.87l1.355 11.879h0.766l1.086-8.854c0.052-0.394 0.077-0.788 0.115-1.183h0.039c0.063 0.678 0.101 1.371 0.191 2.049l1.1 7.988h0.766z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(250.93,888.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-0.83v8.082h0.83zm-0.41 9.703c-0.345 0-0.625 0.346-0.625 0.772 0 0.41 0.28 0.756 0.625 0.756 0.334 0 0.614-0.346 0.614-0.756 0-0.426-0.28-0.772-0.614-0.772",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(254.71,894.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.205 0.268-0.473 0.536-0.793 0.536-1.072 0-1.175-2.3-1.175-3.23 0-0.804 0.14-3.183 1.125-3.183 0.383 0 0.626 0.363 0.816 0.726h0.027v-1.275c-0.243-0.252-0.627-0.41-0.946-0.41-1.507 0-1.878 2.615-1.878 4 0 1.529 0.256 4.332 1.916 4.332 0.308 0 0.64-0.109 0.908-0.314z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256.46,895.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h0.025c0.18 0.567 0.537 1.213 1.086 1.197v-1.197l-0.165 0.015c-0.856 0-0.946-1.023-0.946-2.316v-4.709h-0.83v8.082h0.83z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(258.92,892.23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-0.789 0.025-3.213 1.021-3.213 0.998 0 1.023 2.424 1.023 3.213 0 0.772-0.025 3.198-1.023 3.198-0.996 0-1.021-2.426-1.021-3.198m2.901 0c0-1.529-0.154-4.174-1.88-4.174-1.724 0-1.877 2.645-1.877 4.174 0 1.512 0.153 4.158 1.877 4.158 1.726 0 1.88-2.646 1.88-4.158",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(265.29,894.61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-0.025c-0.243 0.424-0.626 0.819-1.086 0.819-0.499 0-0.818-0.473-0.818-1.071 0-0.772 0.536-1.246 1.061-1.781 0.536-0.551 1.06-1.149 1.06-2.205-1e-3 -1.292-0.702-2.315-1.788-2.315-0.41 0-0.87 0.236-1.19 0.551v1.197c0.32-0.41 0.665-0.787 1.163-0.787 0.575 0 0.958 0.551 0.958 1.228 0 0.803-0.523 1.339-1.06 1.922-0.523 0.567-1.061 1.197-1.061 2.158 0 1.213 0.653 2.063 1.636 2.063 0.422 0 0.818-0.203 1.15-0.519z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(268.99,892.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 1.244-0.012 3.246-0.971 3.246-0.882 0-0.92-1.67-0.92-3.105 0-1.559 0.051-3.559 0.958-3.559 0.766 0 0.933 0.928 0.933 3.418m-1.814 3.402h0.025c0.256 0.442 0.549 0.678 1.023 0.678 1.519 0 1.622-2.442 1.622-4.08 0-1.828-0.038-4.254-1.559-4.254-0.473 0-0.843 0.299-1.086 0.756h-0.026v-3.717h-0.829v11.17h0.83z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(271.63,895.61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.332 0.473 0.778 0.771 1.29 0.771 1.201 0 1.266-1.291 1.266-2.425v-5.782h-0.832v5.608c1e-3 1.26-0.114 1.765-0.741 1.765-0.945 0-0.983-1.277-0.983-2.127v-5.246h-0.83v12.602h0.83z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(277.92,892.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-0.012 0.141c-0.026 0.773-0.051 2.412-0.921 2.412-0.792 0-0.97-1.828-0.97-2.553zm-1.916-0.867v-0.235c0-0.804 0.115-2.757 1.021-2.757 0.728 0 0.832 1.26 0.832 1.906h0.854c-0.011-1.229-0.395-2.867-1.609-2.867-1.725 0-1.955 2.521-1.955 4.142 0 1.45 0.257 4.19 1.84 4.19 1.533 0 1.776-2.471 1.776-3.889v-0.49z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280.55,895.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h0.025c0.18 0.568 0.537 1.213 1.086 1.197v-1.197l-0.166 0.015c-0.857 0-0.945-1.023-0.945-2.316v-4.709h-0.83v8.082h0.83z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.92,892.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-0.013 0.141c-0.025 0.773-0.05 2.412-0.92 2.412-0.792 0-0.971-1.828-0.971-2.553zm-1.916-0.867v-0.235c0-0.804 0.115-2.757 1.021-2.757 0.728 0 0.832 1.26 0.832 1.906h0.854c-0.013-1.229-0.396-2.867-1.609-2.867-1.725 0-1.955 2.521-1.955 4.142 0 1.45 0.256 4.19 1.84 4.19 1.533 0 1.776-2.471 1.776-3.889v-0.49z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(289.23,894.61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-0.025c-0.243 0.424-0.626 0.82-1.086 0.82-0.499 0-0.818-0.474-0.818-1.072 0-0.772 0.536-1.246 1.061-1.781 0.536-0.551 1.06-1.149 1.06-2.205-1e-3 -1.292-0.704-2.315-1.79-2.315-0.408 0-0.868 0.236-1.188 0.551v1.197c0.32-0.41 0.665-0.787 1.163-0.787 0.575 0 0.958 0.551 0.958 1.228 0 0.803-0.523 1.339-1.06 1.922-0.524 0.567-1.061 1.197-1.061 2.158 0 1.213 0.652 2.063 1.636 2.063 0.422 0 0.818-0.203 1.15-0.519z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.97,874.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-0.895v11.879h0.895z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(156.15,881.71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.332 0.473 0.78 0.771 1.29 0.771 1.163 0 1.266-1.322 1.266-2.425v-5.782h-0.832l1e-3 5.672c0 0.961-0.052 1.701-0.742 1.701-0.945 0-0.983-1.277-0.983-2.127v-5.246h-0.831v8.082h0.831z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160.68,871.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-0.83v11.059h0.83zm-0.41 12.682c-0.344 0-0.626 0.346-0.626 0.771 0 0.409 0.282 0.756 0.626 0.756 0.334 0 0.614-0.347 0.614-0.756 0-0.425-0.28-0.771-0.614-0.771",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(164.41,878.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-0.013 0.141c-0.025 0.773-0.05 2.412-0.92 2.412-0.792 0-0.971-1.828-0.971-2.553zm-1.916-0.867v-0.235c0-0.804 0.115-2.757 1.021-2.757 0.728 0 0.832 1.26 0.832 1.906h0.854c-0.011-1.229-0.395-2.867-1.609-2.867-1.725 0-1.955 2.521-1.955 4.142 0 1.45 0.256 4.19 1.84 4.19 1.533 0 1.776-2.473 1.776-3.889v-0.49z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168.85,880.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.205 0.268-0.473 0.535-0.792 0.535-1.074 0-1.176-2.299-1.176-3.229 0-0.804 0.14-3.183 1.125-3.183 0.383 0 0.626 0.363 0.818 0.726h0.025v-1.277c-0.243-0.252-0.627-0.408-0.945-0.408-1.508 0-1.879 2.613-1.879 4 0 1.529 0.256 4.332 1.916 4.332 0.308 0 0.64-0.109 0.908-0.315z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(172.03,881.41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-1.086v-7.137h-0.83v7.137h-0.703v0.945h0.703v2.206h0.83v-2.206h1.086z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(174.09,881.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.92 0-0.971-1.795-0.971-3.166 0-3.34 0.448-3.498 0.933-3.498 0.804 0 0.958 0.93 0.958 3.466 0 1.749-0.102 3.198-0.92 3.198m1.673-7.373h-0.83v0.63h-0.025c-0.243-0.456-0.613-0.755-1.086-0.755-1.048 0-1.56 0.724-1.56 4.252 0 1.813 0.052 4.082 1.636 4.082 0.46 0 0.754-0.238 1.01-0.678h0.025v0.551h0.83z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.56,878.48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 1.844-0.14 3.166-0.971 3.166-1.01 0-0.92-2.379-0.92-3.103 0-0.993-0.102-3.561 0.958-3.561 0.678 0 0.933 0.725 0.933 3.498m-2.644 8.397h0.83v-5.073h0.025c0.243 0.457 0.549 0.678 1.023 0.678 1.521 0 1.622-2.254 1.622-4.08 0-2.049-0.128-4.254-1.559-4.254-0.472 0-0.843 0.299-1.086 0.756h-0.025v-0.631h-0.83z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(182.2,874.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-0.831v12.602h0.831z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(185.93,878.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-0.013 0.142c-0.025 0.772-0.05 2.411-0.92 2.411-0.792 0-0.971-1.828-0.971-2.553zm-1.916-0.867v-0.235c0-0.804 0.115-2.757 1.021-2.757 0.728 0 0.832 1.26 0.832 1.906h0.854c-0.011-1.229-0.395-2.867-1.609-2.867-1.725 0-1.955 2.521-1.955 4.142 0 1.45 0.256 4.19 1.84 4.19 1.533 0 1.776-2.473 1.776-3.889v-0.49z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(193.54,884.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.383 0.536-0.805 0.961-1.418 0.961-0.895 0-1.393-0.914-1.393-1.922 0-1.386 0.818-2.033 1.648-2.725 0.818-0.709 1.636-1.465 1.636-3.103 0-1.733-0.908-3.372-2.416-3.372-0.536 0-1.085 0.19-1.519 0.598v1.434c0.408-0.535 0.944-0.961 1.558-0.961 0.946 0 1.469 1.025 1.457 2.095 0.012 1.387-0.818 2.001-1.636 2.71-0.818 0.693-1.648 1.465-1.648 3.166 0 1.592 0.792 3.152 2.21 3.152 0.576 0 1.061-0.236 1.521-0.631z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(195.75,882.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-5.073c0-1.103 0.051-2.174 0.868-2.174 0.843 0 0.883 1.071 0.895 2.174v5.073h0.831v-5.94c0-1.355-0.538-2.267-1.713-2.267-1.163 0-1.712 0.898-1.712 2.267v5.94z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(201.95,880.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-0.025c-0.243 0.424-0.626 0.82-1.086 0.82-0.499 0-0.818-0.474-0.818-1.072 0-0.772 0.536-1.244 1.061-1.781 0.536-0.551 1.06-1.149 1.06-2.205 0-1.292-0.704-2.315-1.79-2.315-0.408 0-0.868 0.236-1.188 0.551v1.197c0.32-0.41 0.665-0.787 1.163-0.787 0.575 0 0.958 0.551 0.958 1.228 0 0.804-0.523 1.339-1.06 1.923-0.524 0.566-1.061 1.197-1.061 2.158 0 1.212 0.652 2.064 1.636 2.064 0.422 0 0.818-0.205 1.15-0.521z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(205.64,878.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 1.244-0.013 3.246-0.971 3.246-0.882 0-0.92-1.67-0.92-3.105 0-1.559 0.051-3.559 0.958-3.559 0.766 0 0.933 0.928 0.933 3.418m-1.814 3.403h0.025c0.256 0.441 0.549 0.677 1.023 0.677 1.521 0 1.622-2.442 1.622-4.08 0-1.828-0.038-4.252-1.559-4.252-0.473 0-0.843 0.297-1.086 0.754h-0.025l-1e-3 -3.717h-0.829v11.17h0.83z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210.04,878.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-0.012 0.141c-0.026 0.773-0.051 2.412-0.921 2.412-0.792 0-0.97-1.828-0.97-2.553zm-1.916-0.867v-0.236c0-0.803 0.115-2.756 1.021-2.756 0.728 0 0.832 1.26 0.832 1.906h0.856c-0.013-1.229-0.397-2.867-1.611-2.867-1.725 0-1.955 2.521-1.955 4.142 0 1.45 0.256 4.19 1.84 4.19 1.533 0 1.776-2.473 1.776-3.889v-0.49z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(212.67,881.71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.332 0.473 0.778 0.771 1.29 0.771 1.163 0 1.266-1.322 1.266-2.425v-5.782h-0.832l1e-3 5.672c0 0.961-0.052 1.701-0.742 1.701-0.945 0-0.983-1.277-0.983-2.127v-5.246h-0.831v8.082h0.831z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(218.88,880.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-0.025c-0.243 0.424-0.626 0.82-1.086 0.82-0.499 0-0.818-0.474-0.818-1.072 0-0.772 0.536-1.244 1.061-1.781 0.536-0.551 1.06-1.149 1.06-2.205 0-1.292-0.704-2.315-1.79-2.315-0.408 0-0.868 0.236-1.188 0.551v1.197c0.32-0.41 0.665-0.787 1.163-0.787 0.575 0 0.958 0.551 0.958 1.228 0 0.804-0.523 1.339-1.06 1.923-0.524 0.566-1.061 1.197-1.061 2.158 0 1.212 0.652 2.064 1.636 2.064 0.422 0 0.818-0.205 1.15-0.521z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(220.76,874.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-0.831v8.082h0.831zm-0.408 9.704c-0.345 0-0.627 0.347-0.627 0.771 0 0.41 0.282 0.756 0.627 0.756 0.332 0 0.613-0.346 0.613-0.756 0-0.424-0.281-0.771-0.613-0.771",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(222.58,878.32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-0.787 0.025-3.213 1.023-3.213 0.996 0 1.021 2.426 1.021 3.213 0 0.772-0.025 3.198-1.021 3.198-0.998 0-1.023-2.426-1.023-3.198m2.901 0c0-1.527-0.154-4.174-1.878-4.174-1.726 0-1.879 2.647-1.879 4.174 0 1.512 0.153 4.159 1.879 4.159 1.724 0 1.878-2.647 1.878-4.159",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.28,881.71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.332 0.473 0.778 0.771 1.29 0.771 1.163 0 1.264-1.322 1.264-2.425v-5.782h-0.83l1e-3 5.672c0 0.961-0.052 1.701-0.742 1.701-0.945 0-0.983-1.277-0.983-2.127v-5.246h-0.831v8.082h0.831z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231.28,871.74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-0.612 0.363 0.982 3.653 0.906-0.502z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(238.44,878.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-2.189-0.14-3.922-2.019-3.922-1.93 0-2.018 1.795-2.018 3.922v8.113h0.895v-8.05c-1e-3 -1.969 0.088-2.914 1.123-2.914 1.023 0 1.124 0.945 1.124 2.914v8.05h0.895z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243.29,884.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.383 0.537-0.805 0.961-1.418 0.961-0.895 0-1.393-0.914-1.393-1.922 0-1.385 0.818-2.033 1.648-2.725 0.818-0.709 1.636-1.465 1.636-3.103 0-1.733-0.908-3.372-2.416-3.372-0.536 0-1.085 0.19-1.519 0.598v1.434c0.408-0.535 0.944-0.961 1.559-0.961 0.945 0 1.468 1.025 1.456 2.095 0.012 1.387-0.818 2.001-1.636 2.71-0.818 0.693-1.648 1.465-1.648 3.166 0 1.592 0.793 3.152 2.211 3.152 0.575 0 1.06-0.236 1.52-0.631z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245.81,880.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h0.345c1.253 0 1.406 0.567 1.444 2.096 0 1.638-0.358 2.08-1.611 2.08h-0.178zm-0.895-6.695v11.879h0.997c1.381 0 2.607-0.159 2.607-3.088 0-2.301-0.651-3.104-2.479-3.104h-0.23v-5.687z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(249.11,873.22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.971 1.937 1.533 4.158 1.481 6.379 0.052 2.207-0.51 4.443-1.481 6.381l0.64 0.33c1.021-2.063 1.609-4.395 1.558-6.711 0.051-2.315-0.524-4.647-1.558-6.711z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptisonLogo);
export default __webpack_public_path__ + "static/media/optison-logo.4362a135fdb0e187cd0d1ef4eef2603e.svg";
export { ForwardRef as ReactComponent };